import React from 'react';
import { Path } from 'react-native-svg';
import SVGIcon from './SVGIcon';
import withDefaultIconProps from './withDefaultIconProps';
const BriefCaseIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { fill: color, fillRule: "evenodd", d: "M15 3.5a1 1 0 0 1 1 1V7h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h4V4.5a1 1 0 0 1 1-1h6ZM9.5 7h5V5h-5v2Z", clipRule: "evenodd" })));
};
export default withDefaultIconProps(BriefCaseIcon);
